import type { JSX } from 'react'

// for the correct size of this icon, you must additionally set the size in the place of use for <Icon size={IconSocialSizes.appStore}
export const AppStoreIcon = (): JSX.Element => (
  <use href='#appStoreIcon' height='28px' width='96px' />
)
